<template lang="pug">
  div( :id="key_id" )
    b-row
      b-col( cols="7" )
        autosave-input(
            :value="customer_id_input.value"
            :params="customer_id_input"
            :id="id"
            :index="index"
            :record_type="record_type"
            :url="url"
            @input="on_change"
            @on_save="save_customer_order")

      b-col( cols="1" )
        customer-validations(:errors="errors" :id="customer_id")
      b-col( cols="4")
        b-form-group( class="float-right")
          b-input-group
            b-button(
                v-if="customer_id"
                class="mr-2"
                size="md"
                @click="open_modal"
                variant="outline-secondary")
              icon( icon="pen")

            b-button( variant="outline-secondary" @click="$emit('delete_click', index)")
              i( class="fas fa-trash")


    modal( title="Изменить данные клиента"
           :show="show_modal"
           :modal_id="modal_id"
           v-on:modal_hide="show_modal = false"
           v-on:modal_show="show_modal = true")

      template( v-slot:default)
        CustomerForm(
            v-if="show_modal"
            action="edit"
            :role="role"
            :id="customer_id"
            @submit_ok="update_customer")

</template>

<script>
  import AutosaveInput from '../../components/base/AutosaveInput.vue';
  import Icon from "../base/Icon";
  import Modal from "../Modal";
  import CustomerForm from "./CustomerForm";
  import CustomerValidations from "../common/CustomerValidations";

  export default {
    components: {
      CustomerValidations,
      CustomerForm,
      Modal,
      Icon,
      AutosaveInput
    },
    props: {
      id: Number,
      order_id: [Number, String],
      customer_id: [Number, String],
      objects: Array,
      index: Number,
      lang: String,
      role: {
        type: String,
        default: 'user',
      }
    },
    data() {
      let prefix = '', module_name = 'orders';
      if (this.role === 'agent') {
        prefix = '/agent';
        module_name = 'agents'
      }
      return {
        record_type: 'customer_order',
        collection: this.objects,
        show_modal: false,
        modal_id: 'edit_customer_modal_' + this.id,
        url_prefix: prefix,
        module_name,
      }
    },
    computed:{
      customer_id_input() {
        return {
          value: this.customer_id,
          field: 'customer_id',
          name: 'customer_order[customer_id]',
          label: null,
          type: 'text',
          mode: 'select2',
          one_word_search: true,
          get_options_url: `${this.url_prefix}/customers`,
          option_label: 'full_name',
          collection: this.objects,
          has_error: false,
          error_hint: null,
          extra_data: {
            order_id: this.order_id,
          },
          search_data: {
            order_id: this.order_id,
          }
        };
      },
      name() {
        let customer;
        customer = _.find(this.objects, {id: String(this.customer_id)});
        return customer ? customer.attributes.route : 'none';
      },
      url() {
        return this.id ? (`${this.url_prefix}/customer_orders/${this.id}`) : `${this.url_prefix}/customer_orders`
      },
      key_id(){
        return 'customer-order-item-' + this.key;
      },
      customer(){
        return this.$store.getters[`${this.module_name}/customer`](this.customer_id)
      },
      errors(){
        if (this.customer) return this.customer.attributes.validations_for_lang[this.lang]
      }

    },
    methods: {
      open_modal() {
        this.show_modal = true;
      },
      hide_modal() {
        this.show_modal = false;
      },
      on_change (data, field) {
        // console.log('on_change', data, field);
        // this.$set(this.inputs.title, 'value', data);
      },
      save_customer_order(item, index) {
        this.$emit('save', item, index);
      },
      update_customer(customer) {
        this.hide_modal();
        this.$emit('save', customer, this.index);
      }
    }

  }
</script>